'use client'
import React, { useState } from "react";
import Image from "next/image";
import Gallery from '@components/Gallery'

const gallery = [
    '/images/sold/sold-by-remax-island-real-estate-01.jpg',
    '/images/sold/sold-by-remax-island-real-estate-02.jpg',
    '/images/sold/sold-by-remax-island-real-estate-03.jpg',
    '/images/sold/sold-by-remax-island-real-estate-04.jpg',
    '/images/sold/sold-by-remax-island-real-estate-05.jpg',
    '/images/sold/sold-by-remax-island-real-estate-06.jpg',
    '/images/sold/sold-by-remax-island-real-estate-07.jpg',
    '/images/sold/sold-by-remax-island-real-estate-08.jpg',
    '/images/sold/sold-by-remax-island-real-estate-09.jpg',
    '/images/sold/sold-by-remax-island-real-estate-11.jpg',
    '/images/sold/sold-by-remax-island-real-estate-12.jpg',
    '/images/sold/sold-by-remax-island-real-estate-14.jpg',
    '/images/sold/sold-by-remax-island-real-estate-15.jpg',
    '/images/sold/sold-by-remax-island-real-estate-16.jpg',
    '/images/sold/sold-by-remax-island-real-estate-17.jpg',
    '/images/sold/sold-by-remax-island-real-estate-4.jpg',
    '/images/sold/sold-by-remax-island-real-estate-8.jpg',
    '/images/sold/sold-by-remax-island-real-estate-10.jpg',
    '/images/sold/sold-by-remax-island-real-estate-13.jpg',
    '/images/sold/sold-by-remax-island-real-estate-18.jpg',
]

const SoldComponent = ({ dictionary }) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [isPopupOpen, setPopupOpen] = useState(false);

    const openPopup = (index) => {
        if (gallery && gallery.length > 0) {
            setActiveSlide(index)
            setPopupOpen(true);
        }
    };

    const closePopup = () => {
        setPopupOpen(false);
    };

  return (
    <div className='md:w-full xl:w-10/12 mx-auto p-2'>
        <h3 className='text-xl text-maincolor font-bold'>{dictionary.section.ourHappyCustomers}</h3>
        <p className="mb-2">{dictionary.section.nobodySellsMore}</p>
        <div className='flex flex-row flex-wrap'>
            {gallery && gallery.map((image, index) => (
                <div key={index} className='sm:w-1/4 w-1/2 p-1'>
                    <div className='relative aspect-[4/3] rounded-md overflow-hidden'>
                        <Image
                            onClick={() => openPopup(index)}
                            // onClick={() => openPopup(index)}
                            // placeholder="blur"
                            // blurDataURL={property.blur}
                            // className='object-fit'
                            className='object-cover cursor-pointer hover:shadow-xl'
                            src={`${image}`}
                            // width={imageWidth}
                            // height={imageHeight}
                            fill={true}
                            alt={``}
                        />
                    </div>
                </div>
            ))
        }
        </div>
        <Gallery isOpen={isPopupOpen} onClose={closePopup} gallery={gallery} initialSlide={activeSlide} altName={''} />

    </div>
  )
}

export default SoldComponent